import type { ReactNode } from 'react';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { VendorLedgerView } from '../../components/LedgerStatement.js';

/** The vendor's own ledger: its account with the tenant (GET /v1/vendor/ledger). */
export function MyLedgerPage(): ReactNode {
  const { t } = useTranslation();
  return (
    <div style={{ padding: 24 }}>
      <VendorLedgerView path="/v1/vendor/ledger" title={() => t('ledger.my.title')} note={t('ledger.my.note')} />
    </div>
  );
}
